import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import bg from '../assets/images/hero/auth.jpg'
import logo from '../assets/images/branding/logo-hap.svg'
import useCsrfToken from '../hooks/useCsrfToken';
import { Turnstile } from '@marsidev/react-turnstile'

export default function ResetPassword() {
    const { csrfToken } = useCsrfToken();
    const TURNSTILE_KEY = '0x4AAAAAABBf7H_LASwjWDgk';
    const [captchaPassed, setCaptchaPassed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorDeliveringMessage, SetErrorDeliveringMessage] = useState('');
    const [errorDelivering, SetErrorDelivering] = useState(false);
    const [successDeliveringMessage, SetSuccessDeliveringMessage] = useState('');
    const [successDelivering, SetSuccessDelivering] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL;

    const handleCallBackTurnstile = (data) => {
        setCaptchaPassed(true);
    }

    const handleExpirationTurnstile = () => {
        setCaptchaPassed(false);
        // console.log('Turnstile - expired');
    }

    const handleSubmit = async (e) => {
        setIsLoading(true);
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);

        const data = {
            email: formData.get('email'),
            captcharesponse: formData.get('cf-turnstile-response'),
            _token: csrfToken
        };

        try {
            const response = await fetch(`${API_URL}/api/arandaplus/passwordrecovery`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(data),
            });

            const result = await response.json();
            if (result.status === 'success' && result.token !== '') {
                SetErrorDeliveringMessage('');
                SetErrorDelivering(false);
                SetSuccessDeliveringMessage(result.message);
                SetSuccessDelivering(true);
                form.reset();
                setIsLoading(false);
                setCaptchaPassed(false);
            } else {
                SetErrorDeliveringMessage(result.message);
                SetErrorDelivering(true);
                SetSuccessDelivering(false);
                setIsLoading(false);
            }
        } catch (error) {
            SetErrorDeliveringMessage(error);
            SetErrorDelivering(true);
            SetSuccessDelivering(false);
            setIsLoading(false);
        }
    };
    return (
        <>
            <section className="bg-home d-flex align-items-center" style={{ backgroundImage: `url(${bg})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-linear-gradient-2"></div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-5 col-md-6 col-12">
                            <div className="p-4 bg-white rounded shadow-md mx-auto w-100" style={{ maxWidth: '400px' }}>
                                <form onSubmit={handleSubmit}>
                                    <Link to="/"><img src={logo} className="mb-4 d-block mx-auto w-50 p-2" alt="" /></Link>
                                    <h6 className="mb-2 text-uppercase fw-semibold">Recupere su acceso</h6>
                                    <p className="text-muted">Ingrese su correo electrónico para recibir una nueva contraseña.</p>
                                    <div className="mb-3">
                                        <label className="form-label fw-semibold">Su Email</label>
                                        <input name="email" id="email" type="email" className="form-control border-primary" placeholder="correo electrónico" />
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <Turnstile siteKey={TURNSTILE_KEY} onSuccess={handleCallBackTurnstile} onExpire={handleExpirationTurnstile} />
                                        </div>
                                    </div>
                                    {captchaPassed && !isLoading && (
                                        <button className="btn btn-primary w-100 mt-2" type="submit">Solicitar contraseña</button>
                                    )}
                                    {isLoading && (
                                        <div className="spinner-border text-success mx-auto my-2 text-center" role="status">
                                            <span className="visually-hidden text-center">Solicitando, espere...</span>
                                        </div>
                                    )}
                                    {errorDelivering && (
                                        <>
                                            <br />
                                            <div className="alert alert-warning text-dark alert-dismissible fade show mt-4" role="alert">
                                                <strong>No se pudo realizar la solicitud, revise lo siguiente: </strong> {errorDeliveringMessage}
                                            </div>
                                        </>
                                    )}
                                    {successDelivering && (
                                        <>
                                            <br />
                                            <div className="alert alert-success alert-dismissible fade show mt-4" role="alert">
                                                <strong>{successDeliveringMessage}</strong>
                                            </div>
                                        </>
                                    )}

                                    <div className="col-12 text-center mt-3">
                                        <span><span className="text-muted small me-2">¿Ya recuperó su contraseña? </span> <Link to="/login" className="text-dark fw-semibold small">Iniciar sesión</Link></span>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
